import { Component, Input } from '@angular/core';
import { FixedCutterPreBOMInput, BOM_FixedCutterInput, Picklist_HardfacingDetail, Picklist_RingGauge } from '../../interfaces/request';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, filter, Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
import { RequestActions } from '../../store/action/request.action';

@Component({
    selector: 'app-sapdocuments-data',
    templateUrl: './sapdocuments-data.component.html',
    styleUrls: ['./sapdocuments-data.component.css'],
    standalone: false
})
export class SapdocumentsDataComponent {
  @Input() public HardFacingDetailLookUp!: Picklist_HardfacingDetail[];
  @Input() public BomMaskingDetail!: Picklist_HardfacingDetail[];
  @Input() public BomSacrificalDetail!: string[];
  @Input() public AngleBoxDetail!: string[];
  @Input() public GaugeByBitSize!: Picklist_RingGauge[];
  @Input() public HardFacingSleeveLookup!: string[];
  @Input() public BomMaskingSleeve!: string[];
  @Input() public BomSacrificalSleeve!: string[];

  @Input() sapInitial$?: Observable<FixedCutterPreBOMInput>;
  @Input() draftId?: number;
  private destroy$ = new Subject<void>();

  public appRouterData!: FormGroup;
  private latestSapInput!: FixedCutterPreBOMInput;

  constructor(private store: Store, private fb: FormBuilder) {
    this.appRouterData = this.fb.group({
      IncludeDR10000: [null],
      SteelRelief: [null],
      BitHead_HardFacingDetail: [null],
      BitHead_MaskingDetail: [null],
      BitHead_SacrificalBoxName: [null],
      BitHeadRingGauge: [null],
      Sleeve_HardFacingDetail: [null],
      Sleeve_MaskingDetail: [null],
      Sleeve_SacrificalBox: [null]
    });
  }
  ngOnInit(): void {
    if (!this.sapInitial$) {
      return;
    }

    this.sapInitial$
      .pipe(takeUntil(this.destroy$))
      .subscribe(sap => {
        this.latestSapInput = sap;
        const inpu = sap.FixedCutterInput as BOM_FixedCutterInput;
        this.appRouterData.patchValue({
          IncludeDR10000: inpu.includeDR10000,
          SteelRelief: inpu.steelRelief,
          BitHead_HardFacingDetail: inpu.bitHead_HardFacingDetail,
          BitHead_MaskingDetail: inpu.bitHead_MaskingDetail,
          BitHead_SacrificalBoxName: inpu.bitHead_SacrificalBoxName,
          //BitHeadRingGauge: inpu.bitHeadRingGauge,
          Sleeve_HardFacingDetail: inpu.sleeve_HardFacingDetail,
          Sleeve_MaskingDetail: inpu.sleeve_MaskingDetail,
          Sleeve_SacrificalBox: inpu.sleeve_SacrificalBox
        }, { emitEvent: false });
      });

    this.appRouterData.valueChanges
      .pipe(
        debounceTime(200),
        filter(() => !!this.latestSapInput && !!this.draftId),
        takeUntil(this.destroy$)
      )
      .subscribe(changes => {
        const updated: FixedCutterPreBOMInput = {
          ...this.latestSapInput,
          FixedCutterInput: {
            ...this.latestSapInput.FixedCutterInput,
            ...changes
          }
        };
        this.store.dispatch(new RequestActions.PatchRequestDraft({
          draftId: this.draftId,
          changes: { fixedCutterSapData: updated }
        }));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
